import React, { useState } from "react";
import NavBarComponent from "../NavBarComponent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { faArrowDown } from "@fortawesome/free-solid-svg-icons";
import { faFacebookSquare } from "@fortawesome/free-brands-svg-icons";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import { faGithub } from "@fortawesome/free-brands-svg-icons";
import { faPaperPlane } from "@fortawesome/free-regular-svg-icons";
import styled from "styled-components";
import Footer from "../Footer/Footer";
import { H1Heading } from "../../common/CommonStyles";
import axios from "axios";
import { MAIL_SUBJECT } from "../../common/constants";

const ContactIcons = styled(FontAwesomeIcon)`
  font-size: 16vw;
  margin: 100px 15px auto 15px;
`;
const SendMessageText = styled.p`
  color: #ffffff;
  margin-top: 6rem;
  &:hover {
    cursor: pointer;
    color: yellow;
  }
`;
const ModalWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  width: 70%;
  height: 70%;
  background-color: #ffffff;
  display: ${(props) => (props.isModalOpen ? "block" : "none")};
  border-radius: 10px;
`;

const CloseModalBtn = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  margin: 3px 5px;
  border: none;
  background-color: #fff;
  font-weight: 900;

  padding: 5px 10px;
`;

const InputBar = styled.input`
  width: 90%;
  margin-top: 20px;
  margin-bottom: 10px;
  padding: 5px 10px;
  @media (max-width: 500px) {
    margin-top: 38px;
  }
  border: 2px solid #7f8caa;
`;

const TextBox = styled.textarea`
  width: 90%;
  height: 60%;
  resize: none;
  padding: 5px 10px;
  border: 2px solid #7f8caa;
`;

const RelativeDivContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  padding: 20px 15px;
  @media (max-width: 500px) {
    padding: 15px 7.5px;
  }
`;

const Button = styled.button`
  position: relative;
  border-radius: 5px;
  border: none;
  font-weight: 700;
  text-align: center;
  padding: 5px 20px;
  background-color: yellow;
  &:disabled {
    background-color: #eee;
    cursor: not-allowed;
  }
`;

//React Component
function Contact() {
  const [name, setName] = useState("");
  const [message, setMessage] = useState("");
  const [email, setEmail] = useState("");
  const [errMessage, setErrMessage] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const onClickMsgHandler = () => {
    setIsModalOpen(true);
  };
  const closeModal = () => {
    // references are now sync'd and can be accessed.
    setIsModalOpen(false);
  };
  const handleData = (e) => {
    if (e.target.name === "name") setName(e.target.value);
    if (e.target.name === "message") setMessage(e.target.value);
    if (e.target.name === "email") setEmail(e.target.value);
    setErrMessage("");
  };

  const sendMessage = () => {
    setErrMessage("");
    document.getElementById("sendmsgbtn").disabled = true;
    const API_ENDPOINT = "https://api.rajdeepjadhav.in";
    let finalMsg = `From: ${email}\n${message}`;

    if (name != null && finalMsg != null) {
      axios
        .post(API_ENDPOINT + "/sendMail", {
          recipient: "rajdeepj1363@gmail.com",
          msgBody: finalMsg,
          subject: MAIL_SUBJECT.concat(name),
        })
        .then((response) => {
          console.log("Message sent successfully", response);
          setIsModalOpen(false);
          alert(
            "I have received your message, will get back to you soon " +
              name +
              "!"
          );
        })
        .catch((error) => {
          console.log("Issue in sending message", error);
          setErrMessage(
            "There was some issue sending message, please try again in some time!"
          );
          setIsModalOpen(false);
          setTimeout(() => setErrMessage(""), 5000);
        });
      setName("");
      setMessage("");
      setEmail("");
      document.getElementById("sendmsgbtn").disabled = "false";
    }
  };
  return (
    <>
      <NavBarComponent />
      <section id="contactme" style={{ textAlign: "center" }}>
        <H1Heading>
          <span
            style={{
              color: "yellow",
              fontFamily: "'Bungee', cursive",
              fontSize: "50px",
            }}
          >
            Connect with me{" "}
          </span>{" "}
          <FontAwesomeIcon icon={faArrowDown} />
        </H1Heading>
        <div class="contact-form">
          <div class="social_icons">
            <a href="https://www.linkedin.com/in/rajdeepjadhav">
              <ContactIcons icon={faLinkedin} />
            </a>
            <a href="https://www.facebook.com/rajdeep.jadhav.92/">
              <ContactIcons icon={faFacebookSquare} />
            </a>
            <a href="https://www.instagram.com/rajdeepjadhav.ig/">
              <ContactIcons icon={faInstagram} />
            </a>
            <a href="https://github.com/rajdeepj1363">
              <ContactIcons icon={faGithub} />
            </a>
          </div>
        </div>
        <div>
          <SendMessageText onClick={onClickMsgHandler}>
            Send me a message!{" "}
            <a>
              <FontAwesomeIcon icon={faPaperPlane} />
            </a>
          </SendMessageText>
        </div>
        <ModalWrapper isModalOpen={isModalOpen}>
          <RelativeDivContainer>
            <CloseModalBtn onClick={closeModal}>X</CloseModalBtn>
            <InputBar
              name="name"
              placeholder="Your name"
              onChange={handleData}
              value={name}
            />
            <InputBar
              name="email"
              placeholder="Your email"
              onChange={handleData}
              value={email}
              style={{ marginTop: "-5px" }}
            />
            <TextBox
              name="message"
              placeholder="Your message!"
              onChange={handleData}
              value={message}
            />
            <br />
            <br />
            <Button
              id="sendmsgbtn"
              disabled={name.length === 0 || message.length === 0}
              onClick={sendMessage}
            >
              SEND
            </Button>
          </RelativeDivContainer>
        </ModalWrapper>
        <p style={{ marginTop: "5px", color: "red" }}>{errMessage}</p>
      </section>
      <Footer />
    </>
  );
}

export default Contact;
